import { jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { usePlatformConfig } from '../../hooks/usePlatformConfig';
import useInputLabelDisplay from '../../hooks/useInputLabelDisplay';
import usePriceFormatter from '../../hooks/usePriceFormatter';
const DropdownSelectLabel = ({ label, className, suffix = '', shouldFormatPrice = false, }) => {
    const { getLabel } = useInputLabelDisplay();
    const inputLabel = getLabel(label);
    const { platformConfig: { priceDisplay }, } = usePlatformConfig();
    const { format } = usePriceFormatter({
        currency: priceDisplay.primary.currency,
        decimals: priceDisplay.primary.decimalScale,
        useCurrencySign: false,
    });
    const displayedLabel = !shouldFormatPrice
        ? inputLabel
        : label
            ? format(Number(label))
            : '';
    return (_jsxs(Typography, { className: className, children: [displayedLabel, ` ${suffix}`] }, void 0));
};
export default DropdownSelectLabel;
//# sourceMappingURL=DropdownSelectLabel.js.map